import { render, staticRenderFns } from "./TaskDelayMain.vue?vue&type=template&id=2fa65bb6&scoped=true&"
import script from "./TaskDelayMain.vue?vue&type=script&lang=js&"
export * from "./TaskDelayMain.vue?vue&type=script&lang=js&"
import style0 from "./TaskDelayMain.vue?vue&type=style&index=0&id=2fa65bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa65bb6",
  null
  
)

export default component.exports